{
  "route.tiers.title": "層級和福利",
  "benefits.deleteBenefit.deleteDialog.header": "您確定要刪除此福利嗎？",
  "benefits.deleteBenefit.deleteDialog.content": "刪除此福利後，層級成員不會再收到此福利。",
  "benefits.deleteBenefit.alertDialog.header": "您無法刪除此福利。",
  "benefits.deleteBenefit.alertDialog.content": "此福利已附加至未兌換的成員，請嘗試從福利組合中取消選擇此福利。",
  "benefits.deleteBenefit.failureAlert": "刪除此福利時發生錯誤。",
  "benefits.purchaseBenefits.text": "{pointsText} = 已花費 {currencySymbol}{pointsSpent}",
  "benefits.pointsFromPurchases": "購買的 {pointsPlaceHolder}",
  "benefits.pointsCatalogBenefitData": "其他 {pointsPlaceHolder}",
  "benefits.createNew.button.tooltip": "您必須選擇 [編輯下一個版本] 以編輯和重新啟動福利。",
  "benefits.createNew.button.label": "建立福利",
  "benefits.header.title.regular": "建立固定福利並將其指派給層級，您可在層級設定中定義點數值和購買需求。",
  "benefits.header.title.additional": "建立要向忠誠成員提供的其他福利，您可在忠誠 API 中管理並指派其他福利。",
  "benefits.header.title.fixedBenefits.learnMoreLinkText": "深入瞭解",
  "benefits.header.title.fixedBenefits": "建立固定福利並將其指派給層級，您可在層級設定中定義點數值和購買需求。{learnMoreLink}。",
  "benefits.header.title.additionalBenefits.learnMoreLinkText": "深入瞭解",
  "benefits.header.title.additionalBenefits": "建立要向忠誠成員提供的其他福利，您可使用忠誠 API 或成員設定檔以管理並指派其他福利。{learnMoreLink}。",
  "benefitDefaultData.singleCurrencyText.points": "每 1 {symbol} 花費可取得 1 點",
  "tiers.header.title.learnMoreLinkText": "深入瞭解",
  "tiers.header.title": "建立和編輯層級。啟動計劃後，您僅可新增層級，但無法將其移除。{learnMoreLink}。",
  "tiers.editIcon.tooltip": "若要編輯此層級，您必須完成先前層級設定。",
  "tiers.reviewIcon.tooltip": "顯示層級設定",
  "tiers.status.inactive.tooltip": "您必須完成此層級的設定。",
  "tiers.cardSubtitle.points.text.invitationOnly": "僅邀請層級",
  "tiers.cardSubtitle.points.text.pointsUnderMax": "{points} - 每年取得 {maxPoints} {pointsText}",
  "tiers.cardSubtitle.points.text.pointsAtMax": "每年取得 {points} + {pointsText}",
  "tiers.cardSubtitle.purchasesRequired.plural.zero": "",
  "tiers.cardSubtitle.purchasesRequired.plural.one": "需要購買 {number} 次",
  "tiers.cardSubtitle.purchasesRequired.plural.two": "需要購買 {number} 次",
  "tiers.cardSubtitle.purchasesRequired.plural.few": "需要購買 {number} 次",
  "tiers.cardSubtitle.purchasesRequired.plural.many": "需要購買 {number} 次",
  "tiers.cardSubtitle.purchasesRequired.plural.other": "需要購買 {number} 次",
  "tiers.deleteTierDialog.headline": "您確定要刪除此層級嗎？",
  "tiers.deleteTierDialog.content": "刪除此層級後，層級成員會降至較低層級，不再有目前層級福利。",
  "tiers.addNewCard.tooltip.invalid": "若要建立此層級，您必須完成先前層級設定。",
  "tiers.addNewCard.text": "建立層級",
  "tierSetup.deleteCatalogBenefitDialog.headline": "您確定要刪除此福利嗎？",
  "tierSetup.deleteCatalogBenefitDialog.content": "刪除此福利後，層級成員不再有此福利。",
  "tierSetup.title.new": "建立層級",
  "tierSetup.title.edit": "層級設定 -{name}",
  "benefitSetup.title.new": "建立福利",
  "benefitSetup.title.edit": "編輯福利",
  "benefitSetup.type.title": "選擇福利類型",
  "benefitSetup.benefitName.title": "福利名稱",
  "benefitSetup.benefitName.tooltip": "輸入向成員顯示的此福利名稱。",
  "benefitSetup.targetMarkets.label": "選擇市場",
  "benefitSetup.targetMarkets.tooltip": "選擇此福利的目標市場，請確保已設定所選市場的獎勵區。",
  "benefitSetup.notification": "若要將事件設定為固定福利，首先必須建立事件行動，您可透過所選行動定義此福利的各種層級獎勵。事件固定福利會由自動化中心方案所觸發。",
  "benefitSetupCustomFields.custom.label": "自訂獎勵",
  "benefitSetupCustomFields.custom.tooltip": "向成員顯示的獎勵名稱，您可決定獎勵的兌換方式。",
  "benefitSetupEventFields.eventActionId.label": "選擇行動",
  "benefitSetupEventFields.eventActionId.placeholder": "-- 選擇行動 --",
  "benefitSetupEventFields.tiersAndRewards.title": "層級和獎勵",
  "benefitSetupEventFields.tiersAndRewards.tooltip": "您可透過所選行動定義層級和獎勵，此層級的獎勵會顯示在固定福利表格中。",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.label": "選擇存取",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.placeholder": "-- 選擇存取 -- ",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.tooltip": "已透過存取兌換此福利獎勵，請為每個層級選擇啟用中存取。",
  "benefitSetupVoucherFields.rewardId.label": "選擇憑證集區",
  "benefitSetupVoucherFields.rewardId.placeholder": "-- 選擇憑證集區 --",
  "benefitSetupVoucherFields.rewardId.tooltip": "已透過憑證兌換此福利獎勵，請為每個層級選擇啟用中憑證集區。",
  "benefitSetupVoucherFields.tiersAndRewards.title": "選擇層級和獎勵區",
  "benefitSetupVoucherFields.tiersAndRewards.tooltip": "已透過憑證兌換此福利獎勵，請為每個層級選擇啟用中憑證集區。",
  "benefitSetupExclusiveAccessFields.tiersAndAccess.title": "選擇權杖和存取",
  "benefitSetupExclusiveAccessFields.tiersAndAccess.tooltip": "已透過存取兌換此福利獎勵，請為每個層級選擇啟用中存取。",
  "tierSetupGeneral.tierValueInPointsTooltip.spend": "定義進入此層級所需的最低消費獎勵金額。",
  "tierSetupGeneral.tierValueInPointsTooltip.points": "定義進入此層級所需的最低點數。",
  "tierSetupGeneral.tierValueInPointsTooltip.other": "第一個層級是進入層級，且對所有忠誠客戶開放，不需任何需求。",
  "tierSetupGeneral.numberOfPurchasesTooltip.pointsOrSpend": "定義進入此層級所需的最低購買。此需求為選擇性，並可作為點數需求的補充。",
  "tierSetupGeneral.title": "一般設定",
  "tierSetupGeneral.tierType.label": "層級類型",
  "tierSetupGeneral.inviteTier.notification": "透過呼叫忠誠 API 或手動在成員設定檔中管理您的付款和邀請，並將成員新增至層級。系統會根據計劃設定自動計算取得的點數。您也可在 API 或成員設定檔中定義退出層級的成員行動。",
  "tierSetupGeneral.tierName.label": "層級名稱",
  "tierSetupGeneral.tierName.tooltip": "輸入向成員顯示的此層級名稱，名稱也會顯示為個人化服務中的忠誠權杖。",
  "tierSetupGeneral.tierIcon.label": "層級圖示",
  "tierSetupGeneral.tierIcon.tooltip": "選擇向成員顯示的圖示，圖示也會顯示為個人化服務中的忠誠權杖。",
  "tierSetupGeneral.tierIcon.iconText": "新增至層級 ",
  "tierSetupGeneral.requirements.title": "需求",
  "tierSetupGeneral.tierPoints.label.points": "點數中的值",
  "tierSetupGeneral.tierPoints.label.spend": "層級所需的總消費獎勵",
  "tierSetupGeneral.tierPoints.postfixLabel.points": "點數",
  "tierSetupGeneral.tierPoints.postfixLabel.loyalty": "點數",
  "tierSetupGeneral.tierPoints.postfixLabel.status": "狀態點數",
  "tierSetupGeneral.tierPoints.postfixLabel.balance": "花費點數",
  "tierSetupGeneral.tierPurchases.label": "層級所需的購買數",
  "tierSetupGeneral.tierPurchases.postfixLabel": "購買",
  "tierSetupGeneral.calculation.tierDropout.label": "層級計算",
  "tierSetupGeneral.calculation.tierDropout.tooltip": "選擇是否要在層級計算中包含此層級，或不進行層級計算並退出。",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.label": "層級到期",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.tooltip": "若要使特定層級到期且在與其他層級不同的時間重新計算，請變更此設定。",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.postfixLabel": "年",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.label": "層級到期",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.tooltip": "若要使特定層級到期且在與其他層級不同的時間重新計算，請變更此設定。",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.postfixLabel": "月",
  "tierSetupPurchaseBenefits.tierPurchaseBenefitSpend.options.equal": "每 1 {symbol} 花費授予 1 消費獎勵",
  "tierSetupPurchaseBenefits.catalogSelector.label": "選擇品牌和種類",
  "tierSetupPurchaseBenefits.catalogSelector.placeholder": "選擇要促銷的特定品牌或種類。",
  "tierSetupPurchaseBenefits.catalogSelector.disabledItemsTooltip": "已在先前福利中選擇此種類/品牌。",
  "tierSetupPurchaseBenefits.benefitMessageHeader.title": "福利訊息",
  "tierSetupPurchaseBenefits.benefitMessageHeader.tooltipText": "顯示訊息格式",
  "tierSetupPurchaseBenefits.benefitMessageTitle.label": "標題",
  "tierSetupPurchaseBenefits.benefitMessageTitle.placeholder": "輸入福利訊息標題。",
  "tierSetupPurchaseBenefits.benefitMessageText.label": "內文",
  "tierSetupPurchaseBenefits.benefitMessageText.placeholder": "輸入福利訊息內文",
  "tierSetupPurchaseBenefits.benefitMessageText.tooltip": "向成員顯示的點數和幣別值取決於網站上選擇的幣別。",
  "tierSetupPurchaseBenefits.benefitIcon.label": "福利圖示",
  "tierSetupPurchaseBenefits.benefitIcon.selectIconText": "新增至福利",
  "tierSetupPurchaseBenefits.tierPurchaseBenefitSpend.options.selectedItems": "僅針對所選品牌、種類或行動授予消費獎勵",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.points.first": "為購買特定品牌或產品種類的成員指派不同點數值。授予點數 (非額外授予) 代替標準購買點數。",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.points.other": "如果項目在多個種類中且其中包含點數值，則一律獎勵成員最高定義值。",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.spend.first": "為購買特定品牌或種類的客戶指派不同消費獎勵點數。消費獎勵點數用於更新購買的消費獎勵餘額，而不是標準點數。",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.spend.other": "如果項目在多個種類中且其中包含比率值，則一律獎勵成員最高定義值。",
  "tierSetupPurchaseBenefits.notification": "點數是所有成員的忠誠計劃幣別，請確保所有幣別中的點數值一致。",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.zero": "至少需要 {number} 個點數",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.one": "至少需要 {number} 個點數",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.two": "至少需要 {number} 個點數",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.few": "至少需要 {number} 個點數",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.many": "至少需要 {number} 個點數",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.other": "至少需要 {number} 個點數",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.zero": "至少需要 {number} 個消費獎勵",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.one": "至少需要 {number} 個消費獎勵",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.two": "至少需要 {number} 個消費獎勵",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.few": "至少需要 {number} 個消費獎勵",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.many": "至少需要 {number} 個消費獎勵",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.other": "至少需要 {number} 個消費獎勵",
  "tierSetupPurchaseBenefits.pointsType.title": "層級點數類型",
  "tierSetupPurchaseBenefits.pointsType.label": "點數類型",
  "tierSetupPurchaseBenefits.pointsType.tooltip": "定義成員在層級中授予的點數類型。",
  "tierSetupPurchaseBenefits.pointsType.error": "點數類型與點數乘法行動定義發生衝突。請修正行動：{actions}，然後再試一次。",
  "tierSetupPurchaseBenefits.pointsType.options.loyalty": "點數 (狀態點數和花費點數)",
  "tierSetupPurchaseBenefits.pointsType.options.status": "僅狀態點數",
  "tierSetupPurchaseBenefits.pointsType.options.spend": "僅花費點數",
  "tierSetupPurchaseBenefits.header.points": "購買的點數",
  "tierSetupPurchaseBenefits.header.spend": "購買的忠誠消費獎勵",
  "tierSetupPurchaseBenefits.header.tooltip.spend": "選擇成員從購買取得的消費獎勵金額層級，累計值會在忠誠錢包中向成員顯示。",
  "tierSetupPurchaseBenefits.header.tooltip.points": "選擇層級成員從購買取得的點數金額。如果您管理多個幣別，則必須設定每個幣別的值。如果您不要授予購買點數，則此設定針對所有幣別皆相同。",
  "tierSetupPurchaseBenefits.benefitMessageHeader.tooltip": "輸入在忠誠錢包中向成員顯示的此福利促銷訊息。",
  "tierSetupPurchaseBenefits.catalogBenefit.title.points": "品牌或種類的點數。",
  "tierSetupPurchaseBenefits.catalogBenefit.title.spend": "品牌或種類的忠誠消費獎勵。",
  "tierSetupPurchaseBenefits.catalogBenefit.addNewBtn.points": "新增點數值 ",
  "tierSetupPurchaseBenefits.catalogBenefit.addNewBtn.spend": "新增忠誠消費獎勵值 ",
  "tierSetupVisibility.title": "可見度",
  "tierSetupVisibility.tooltip": "您可向成員隱藏此層級，避免新輸入項。在將現有成員移轉至其他層級前，層級仍會向這些成員顯示。系統將根據計劃設定自動繼續取得的點數計算。",
  "tierSetupVisibility.visible.label": "選擇層級模式",
  "visibility.options.visible": "可見層級",
  "visibility.options.invisible": "隱藏層級",
  "multiLangPurchaseBenefitFields.alert": "輸入所有語言的標題和內文。",
  "additionalBenefitsUpdateValidator.confirmed.isTrue": "請確保您輸入所有必要資訊。",
  "additionalBenefitsUpdateValidator.reason.presence": "輸入內部追蹤目的的原因。",
  "benefitValidator.defaultConstraints.name.presence": "輸入福利名稱。",
  "benefitValidator.defaultConstraints.targetMarkets.presence": "輸入市場。",
  "benefitValidator.eventActionId.presence": "輸入行動。",
  "benefitValidator.custom.presence": "輸入獎勵說明。",
  "benefitValidator.tiers.atLeastOneTier": "選擇至少一個層級。",
  "benefitValidator.rewardConstraints.rewardId.presence": "輸入獎勵區。",
  "benefitValidator.rewardConstraints.tiers.atLeastOneTier": "選擇至少一個層級。",
  "benefitValidator.rewardConstraints.tiers.tierId.rewardId.benefitSingleReward": "選擇空白。",
  "benefitValidator.rewardConstraints.exclusiveAccessIds.presence": "輸入存取。",
  "tiersCreationValidator.numberOfTiers.presence": "輸入 1-10 的數字作為層級數量。",
  "tiersCreationValidator.numberOfTiers.numericality.notInteger": "輸入 1-10 的數字作為層級數量。",
  "tiersCreationValidator.numberOfTiers.numericality.notLessThan": "輸入 1-10 的數字作為層級數量。",
  "tiersCreationValidator.numberOfTiers.numericality.notGreaterThan": "輸入至少兩個要分配的層級。",
  "tiersCreationValidator.spend.presence": "輸入整數作為花費金額。",
  "tiersCreationValidator.spend.numericality.notInteger": "輸入整數作為花費金額。",
  "tiersCreationValidator.spend.numericality.notGreaterThan": "輸入大於先前層級的整數作為花費金額。",
  "rangeTierPoints.nextTierPoints.plural.zero": "最多需要 {number} 個點數",
  "rangeTierPoints.nextTierPoints.plural.one": "最多需要 {number} 個點數",
  "rangeTierPoints.nextTierPoints.plural.two": "最多需要 {number} 個點數",
  "rangeTierPoints.nextTierPoints.plural.few": "最多需要 {number} 個點數",
  "rangeTierPoints.nextTierPoints.plural.many": "最多需要 {number} 個點數",
  "rangeTierPoints.nextTierPoints.plural.other": "最多需要 {number} 個點數",
  "rangeTierPoints.prevTierPoints.plural.zero": "至少需要 {number} 個點數。",
  "rangeTierPoints.prevTierPoints.plural.one": "至少需要 {number} 個點數。",
  "rangeTierPoints.prevTierPoints.plural.two": "至少需要 {number} 個點數。",
  "rangeTierPoints.prevTierPoints.plural.few": "至少需要 {number} 個點數。",
  "rangeTierPoints.prevTierPoints.plural.many": "至少需要 {number} 個點數。",
  "rangeTierPoints.prevTierPoints.plural.other": "至少需要 {number} 個點數。",
  "tierValidator.name.presence": "輸入層級名稱。",
  "tierValidator.name.exclusionIgnoreCase": "此名稱已存在，請輸入唯一名稱。",
  "tierValidator.nameML.multiLangField": "輸入每個語言的層級名稱。",
  "tierValidator.points.presence": "輸入點數中的層級值。",
  "tierValidator.pointsBenefit.titleML.multiLangField": "輸入每個語言的標題。",
  "tierValidator.pointsBenefit.textML.multiLangField": "輸入每個語言的內文。",
  "tierValidator.purchaseBenefits.pointsCatalogBenefits.purchaseBenefitCatalog": "輸入目錄選擇。",
  "tierValidator.pointsRates.points.presence": "輸入點數。",
  "tierValidator.pointsRates.spent.numericality.notInteger": "輸入大於零的數字作為花費。",
  "tierValidator.pointsRates.spent.numericality.notGreaterThan": "輸入大於零的數字作為花費。",
  "tierValidator.pointsRates.spent.presence": "輸入大於零的數字。",
  "benefitDefaultData.pointsBenefitTitle.points": "取得購買的點數",
  "benefitDefaultData.pointsBenefitTitle.spend": "取得購買的忠誠消費獎勵",
  "benefitDefaultData.singleCurrencyText.spend": "購買並取得購買的消費獎勵",
  "purchasePointsToken.display": "{ x 點數 }",
  "purchasePointsToken.display.balance": "{ 可花費的 x 點數}",
  "purchasePointsToken.display.status": "{ x 狀態點數 }",
  "purchaseCurrencyToken.display": "{ x currency }",
  "distribution.contentBox.notification": "預覽現有客戶基礎將如何在層級中分配。在啟動第一個計劃前，您可修改聯絡人分配。",
  "distribution.contentBox.title": "層級建立",
  "distribution.contentBox.numberOfTiers.label": "層級數量",
  "distribution.contentBox.calcPeriod.label": "計算期間",
  "distribution.contentBox.calcPeriod.tooltip": "選擇您要使用多少歷史記錄資料以計算聯絡人分配。",
  "distribution.contentBox.preview.title": "聯絡人分配預覽",
  "distribution.contentBox.preview.tooltip": "僅當聯絡人滿足所有該層級需求，才會將這些聯絡人分配至層級。",
  "distribution.contentBox.updateChartButton.label": "更新圖表",
  "distribution.contentBox.chart.column.label": "客戶數量",
  "distribution.contentBox.chart.series.name": "佔所有客戶的百分比",
  "distribution.contentBox.singleTierSettings.tooltip.first": "第一個層級是進入層級，且對所有忠誠客戶開放，不需任何進入需求。",
  "distribution.contentBox.singleTierSettings.tooltip.spend": "客戶在所選期間內進入此層級的最低總花費。",
  "distribution.contentBox.singleTierSettings.tooltip.purchases": "客戶在所選期間內進入此層級的最低購買數。",
  "distribution.contentBox.singleTierSettings.spend.label": "必要花費",
  "distribution.contentBox.singleTierSettings.purchases.label": "購買數",
  "tierSetupGeneral.tierPoints.postfixLabel.spend": "已花費 {value}",
  "benefitDefaultData.pointsBenefitText.multiCurrency": "為每 {{currencyToken}} 花費賺取 {{pointsToken}}"
}
